<script setup lang="ts">
export interface Props {
  title?: string,
  titleSize?: number,
  error?: boolean;
}
//#region define
const props = withDefaults(defineProps<Props>(), {
  title: '',
  titleSize: 14,
  error: false,
});
//#endregion
</script>

<template>
  <div
    :class="[
      'form-row',
      {'form-row_error': props.error},
    ]"
  >
    <div
      v-if="props.title"
      class="form-row__header"
    >
      <UiLabel
        bold
        :label="props.title"
        :font-size="props.titleSize"
      />
      <slot name="action" />
    </div>
    <slot />
  </div>
</template>

<style lang="scss">
.form-row {
  border-radius: 8px;
  background: var(--background-surface);
  padding: 16px;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &_error {
    border: 1px solid var(--text-negative);
  }
}
</style>

